import { render, staticRenderFns } from "./gzzxDetail.vue?vue&type=template&id=0c2ab7ec&scoped=true"
import script from "./gzzxDetail.vue?vue&type=script&lang=js"
export * from "./gzzxDetail.vue?vue&type=script&lang=js"
import style0 from "./gzzxDetail.vue?vue&type=style&index=0&id=0c2ab7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2ab7ec",
  null
  
)

export default component.exports